export default __webpack_public_path__ + "static/media/orange-carousel-headline-box.cf99ae25.png";